import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class FileService {
  static uploadfile(formData, key) {
    return HttpUtil.post(
      API_ROUTES.EDITFORM.UPLOADFILE.replace("<tokenkey>", key),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data" 
        },
      }
    );
  }

  static downloadFile({ token, fileId, submissionId, isReview = false }) {
    if (submissionId) {
      return HttpUtil.get(API_ROUTES.FILE.DOWNLOAD_BY_SUBMISSION.replace("<submissionId>", submissionId).replace("<id>", fileId), {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else if (isReview) {
      return HttpUtil.get(API_ROUTES.FILE.DOWNLOAD_BY_REVIEW_TOKEN.replace("<tokenkey>", token).replace("<id>", fileId), {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else {
      return HttpUtil.get(API_ROUTES.FILE.DONWLOAD_BY_TOKEN.replace("<tokenkey>", token).replace("<id>", fileId), {
        headers: {
          "Content-Type": "application/json",
        },
      });
    }    
  }

  static updateMetadata(token, id, metadata) {
    return HttpUtil.post(
      API_ROUTES.FILE.UPDATE_METADATA
      .replace("<token>", token)
      .replace("<id>", id),
      metadata
    );
  }

  static deleteFile(token, fileId) {
    return HttpUtil.delete(
      API_ROUTES.FILE.DELETE_BY_TOKEN
      .replace("<tokenkey>", token)
      .replace("<id>", fileId)
    );
  }
}
